import { z } from 'zod'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import {
  adminBillingAccountsQueryOptions,
  adminOrganizationsQueryOptions,
  adminOrgsLastActiveQueryOptions,
} from '@/lib/queries/admin'
import {
  AdminOrgsDialogs,
  AdminOrgsList,
  AdminOrgsPrimaryButtons,
  AdminOrgsProvider,
} from '@/features/admin'

const adminOrganizationsSearchSchema = z.object({
  org_id: z.string().optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/admin/organizations')({
  validateSearch: adminOrganizationsSearchSchema,
  loader: ({ context }) => {
    context.queryClient.query({
      ...adminOrganizationsQueryOptions(),
      staleTime: 'static',
    })
    context.queryClient.query({
      ...adminOrgsLastActiveQueryOptions(),
      staleTime: 'static',
    })
    // Prefetch billing accounts for create dialog combobox + drawer license
    // utilization.
    context.queryClient.query({
      ...adminBillingAccountsQueryOptions(),
      staleTime: 'static',
    })
  },
  component: AdminOrganizationsPage,
})

function AdminOrganizationsPage() {
  const { data: organizations } = useSuspenseQuery(
    adminOrganizationsQueryOptions()
  )

  return (
    <AdminOrgsProvider>
      <div className='w-full space-y-2'>
        <div className='flex items-center justify-between'>
          <div>
            <h2 className='font-heading text-xl'>Organizations</h2>
            <p className='text-muted-foreground text-sm'>
              Manage organizations and their settings
            </p>
          </div>
          <AdminOrgsPrimaryButtons />
        </div>

        <AdminOrgsList data={organizations} />
      </div>

      <AdminOrgsDialogs />
    </AdminOrgsProvider>
  )
}
